import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useDebounce } from "../hooks/useDebounce";

const SearchInput = ({
  label,
  value,
  onChange,
  onInputChange,
  searchQuery, // RTK Query result object with { data, isLoading, error }
  getOptionLabel = (option) => option?.name || "",
  isOptionEqualToValue = (option, value) => option?.id === value?.id,
  renderOption = null,
  groupBy,
  noOptionsText = "No players found",
  placeholder = "Search...",
  fullWidth = true,
  size = "medium",
  variant = "outlined",
  disabled = false,
  required = false,
  error = false,
  helperText = "",
  sx,
}) => {
  const [inputValue, setInputValue] = useState("");

  // Debounced input change handler
  const debouncedInputChange = useDebounce((value) => {
    if (onInputChange) {
      onInputChange(value);
    }
  }, 300);

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
    debouncedInputChange(newInputValue);
  };

  return (
    <Autocomplete
      freeSolo
      fullWidth={fullWidth}
      options={searchQuery?.data || []}
      value={value}
      loading={searchQuery?.isLoading || false}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      onChange={onChange}
      onInputChange={handleInputChange}
      filterOptions={(options) => options}
      groupBy={groupBy}
      open={
        inputValue.length >= 2 &&
        (searchQuery?.data?.length > 0 || searchQuery?.isLoading)
      }
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          {...(label ? { label } : {})}
          variant={variant}
          size={size}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          error={error}
          helperText={helperText}
        />
      )}
      renderOption={renderOption}
      noOptionsText={noOptionsText}
    />
  );
};

export default SearchInput;
